const MAX_SPEED = 160;
/** Degrees of arc the gauge sweeps; matches the dash pattern in index.html. */
const SWEEP = 270;

const bar = document.querySelector('#gauge .bar')!;
const text = document.querySelector('#gauge .text')!;

export function setValue(value: number) {
  text.textContent = `${value}`;
  const red = Math.min(255, Math.round(value * 1.5));
  const len = Math.min(1, value / MAX_SPEED) * SWEEP;
  bar.setAttribute('stroke', `rgb(${red}, 45, 56)`);
  bar.setAttribute('stroke-dasharray', `${len}, ${360 - len}`);
}
